import { render, staticRenderFns } from "./p-header.vue?vue&type=template&id=cc73cf4e&scoped=true"
import script from "./p-header.vue?vue&type=script&lang=js"
export * from "./p-header.vue?vue&type=script&lang=js"
import style0 from "./p-header.vue?vue&type=style&index=0&id=cc73cf4e&prod&lang=css"
import style1 from "./p-header.vue?vue&type=style&index=1&id=cc73cf4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc73cf4e",
  null
  
)

export default component.exports